import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useAuth } from "@/contexts/AuthContext";
import GuideContent, { GUIDE_ROLE_META } from "@/components/guides/GuideContent";

/**
 * Standalone guide page (footer link). The dashboard shows the guide as a
 * modal (GuideModal); this page renders only the single role from the URL —
 * no multi-role switcher — and /guides (no role) redirects to the viewer's
 * own role.
 */
export default function Guides() {
  const { role } = useParams();
  const { user } = useAuth();
  const { t } = useTranslation();
  const r = (role || "").toLowerCase();

  if (!r) {
    if (user?.profile?.is_admin) return <Navigate to="/guides/admin" replace />;
    if (user?.profile?.role === "provider") return <Navigate to="/guides/provider" replace />;
    return <Navigate to="/guides/client" replace />;
  }
  if (!GUIDE_ROLE_META[r]) return <Navigate to="/guides/client" replace />;

  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid={`guide-${r}`}>
      <Navbar />
      <main className="section flex-1">
        <div className="container-app max-w-3xl">
          <Link to="/" className="fx-btn fx-btn--ghost text-sm mb-4 inline-flex" data-testid="back-home">
            <ArrowLeft size={14} /> {t("guides.back")}
          </Link>
          <GuideContent role={r} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
